import type { MatchData } from '../types'
import raw from './sample-match.json'

// Real output of the stats engine for a parsed FACEIT demo (de_dust2, JANO 13–11).
// Phase 1 (live): replace with `fetch('/api/matches/:id').then(r => r.json())` — same shape.
export const sampleMatch = raw as unknown as MatchData

export interface TeamSummary {
  name: string
  score: number
  won: boolean
}

/** Returns the two teams ordered [winner, loser]. */
export function teamSummaries(m: MatchData): [TeamSummary, TeamSummary] {
  const [a, b] = Object.entries(m.team_score)
  const teams = [
    { name: a[0], score: a[1], won: a[1] > b[1] },
    { name: b[0], score: b[1], won: b[1] > a[1] },
  ]
  teams.sort((x, y) => y.score - x.score)
  return teams as [TeamSummary, TeamSummary]
}
